import { CenterItem, Column, Row } from '@components/LinearLayout';

import { P } from '@components/Typography';
import { animated } from '@react-spring/web';
import { EVENT_HOME_WIDTH } from '@utils/constants';
import styled from 'styled-components';

export const FiltersRoot = styled.section<{ $isOnTop: boolean }>`
  position: sticky;
  top: 14rem;
  z-index: 3;
  width: min(${EVENT_HOME_WIDTH}, 100%);
  display: flex;
  gap: 1rem;
  justify-content: end;
  margin: auto;
  margin-bottom: 5rem;
  &:hover {
    cursor: pointer;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    top: 16rem;
    ${({ $isOnTop }) =>
      $isOnTop ? `padding: 0; top: 7rem;` : `padding: 0 2rem;`}
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    ${({ $isOnTop }) => $isOnTop && `padding: 0; top: 7rem;`}
  }
`;

export const FilterBox = styled(animated.div)<{ $isOnTop: boolean }>`
  display: grid;
  place-items: center;
  background-color: ${({ theme }) => theme.color.mobilityGrey};
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  position: relative;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    right: ${({ $isOnTop }) => $isOnTop && '4rem'};
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    right: ${({ $isOnTop }) => $isOnTop && '0'};
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    border-radius: ${({ theme, $isOnTop }) =>
      $isOnTop ? 0 : theme.borderRadius.radius10};
  }
`;

export const DateBox = styled(animated.div)<{
  $isDateHovered: boolean;
  $isOnTop: boolean;
  $isFirst: boolean;
  $isLast: boolean;
}>`
  display: grid;
  place-items: center;
  background-color: ${({ theme }) => theme.color.mobilityGrey};
  position: relative;
  padding: 0 2rem;
  display: ${({ $isOnTop }) => !$isOnTop && 'none'};
  ${({ $isFirst, theme }) =>
    $isFirst &&
    `border-top-left-radius: ${theme.borderRadius.radius10};border-bottom-left-radius: ${theme.borderRadius.radius10};`};
  ${({ $isLast, theme }) =>
    $isLast &&
    `border-top-right-radius: ${theme.borderRadius.radius10};border-bottom-right-radius: ${theme.borderRadius.radius10}; z-index:2`};
`;

export const DateText = styled(P)<{ $color: string }>`
  color: ${({ theme }) => theme.color.white};
  white-space: nowrap;
  &:hover {
    color: ${({ $color }) => $color};
  }
`;

export const DateBoxWrapper = styled(animated.div)`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

export const FilterText = styled(P)<{ $isHovered: boolean; $color: string }>`
  color: ${({ theme, $isHovered, $color }) =>
    $isHovered ? $color : theme.color.white};
  line-height: ${({ theme }) => theme.lineHeight.height30};
  display: flex;
  align-items: center;
`;

export const FilterDarkText = styled(P)<{
  $color: string;
}>`
  color: ${({ $color }) => $color};
  line-height: ${({ theme }) => theme.lineHeight.height30};
  display: flex;
  align-items: center;
`;

export const FilterModalRoot = styled(Column)`
  height: 100%;
  overflow: auto;
  gap: 5rem;
  padding: 2rem;
  margin-right: 1.25rem;
  margin-top: 1rem;
`;

export const ApplyButtonWrapper = styled(CenterItem)`
padding: 2rem 0;,
margin: auto;
box-shadow: 0 -5px 6px -6px rgb(0 0 0 / 0.2);
width: 100%;
`;

export const ClearFilterWrapper = styled(Row)`
  &:hover {
    cursor: pointer;
  }
`;

export const UnselectedDates = styled(animated.div)`
  display: flex;
  gap: 1rem;
  flex-direction: row;
`;

export const AgendaDates = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  margin: auto;
`;

export const DayItem = styled(CenterItem)<{
  $active: boolean;
}>`
  flex: 1 1 10rem;
  width: min(30rem, 100%);
  background-color: ${({ $active, theme }) =>
    $active ? theme.color.mobilityGrey : theme.color.lightGrey2};
  height: 7rem;
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  &:hover {
    background-color: ${({ theme }) => theme.color.mobilityGrey};
    cursor: pointer;
  }
`;
